import { MINUTE_IN_MS, HOUR_IN_MS, DAY_IN_MS, } from '../../common/timeConstants';
export var SupportedResolutions;
(function (SupportedResolutions) {
    SupportedResolutions["ONE_MINUTE"] = "1m";
    SupportedResolutions["FIFTEEN_MINUTES"] = "15m";
    SupportedResolutions["ONE_HOUR"] = "1h";
    SupportedResolutions["ONE_DAY"] = "1d";
})(SupportedResolutions || (SupportedResolutions = {}));
export const RESOLUTION_TO_MS_MAPPING = {
    '0': 0,
    [SupportedResolutions.ONE_MINUTE]: MINUTE_IN_MS,
    [SupportedResolutions.FIFTEEN_MINUTES]: MINUTE_IN_MS * 15,
    [SupportedResolutions.ONE_HOUR]: HOUR_IN_MS,
    [SupportedResolutions.ONE_DAY]: DAY_IN_MS,
};
export const RESOLUTION_TO_DURATION_MAPPING = {
    0: '0',
    [MINUTE_IN_MS]: SupportedResolutions.ONE_MINUTE,
    [MINUTE_IN_MS * 15]: SupportedResolutions.FIFTEEN_MINUTES,
    [HOUR_IN_MS]: SupportedResolutions.ONE_HOUR,
    [DAY_IN_MS]: SupportedResolutions.ONE_DAY,
};
